import { questions } from '../data/questions';

export const calculateScores = (responses) => {
  let totalScore = 0;
  const categoryScores = {};

  for (const [category, answers] of Object.entries(responses)) {
    // Ensure we're handling null or undefined values properly
    const score = answers.reduce((sum, answer) => sum + (answer || 0), 0);
    categoryScores[category] = score;
    totalScore += score;
  }

  // Calculate max possible score based on the new 0-2 point scale (10 questions × 2 points = 20 max)
  const maxTotal = Object.values(questions).reduce((sum, qs) => sum + (qs.length * 2), 0);
  const overallPercentage = Math.round((totalScore / maxTotal) * 100);

  return {
    overallPercentage,
    categoryScores
  };
};

export const getTierLabel = (score) => {
  if (score < 41) return "Needs Professional Help";
  if (score < 71) return "Ready to Scale";
  if (score < 91) return "Optimisation Opportunities";
  return "Industry Leader";
};

export const getTierColor = (tier) => {
  switch (tier) {
    case "Needs Professional Help":
      return "text-danger-500 bg-dark-600 border border-danger-600";
    case "Ready to Scale":
      return "text-warning-500 bg-dark-600 border border-warning-600";
    case "Optimisation Opportunities":
      return "text-primary-500 bg-dark-600 border border-primary-600";
    case "Industry Leader":
      return "text-success-500 bg-dark-600 border border-success-600";
    default:
      return "text-gray-300 bg-dark-600 border border-dark-300";
  }
};

export const getTierAdvice = (tier) => {
  switch (tier) {
    case "Needs Professional Help":
      return "Your fitness business has significant gaps that are costing you leads and sales daily. You need a complete brand and marketing overhaul to compete effectively.";
    case "Ready to Scale":
      return "You have solid foundations but several key areas are holding back your growth. With the right improvements, you could double your leads in 90 days.";
    case "Optimisation Opportunities":
      return "You're doing well but missing advanced strategies that your competitors might be using. Small tweaks could unlock significant growth.";
    case "Industry Leader":
      return "Excellent work! You're ahead of most fitness businesses. Focus on maintaining your edge and scaling further.";
    default:
      return "";
  }
};